export const sanitizePhoneNumber = (value: string) =>
  value ? value.replace(/[^\d]/g, "") : null;

export const phoneNumberMask = (value: string) => {
  const sanitized = sanitizePhoneNumber(value) || "";
  return sanitized.length < 11
    ? [
        "(",
        /[1-9]/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]
    : [
        "(",
        /[1-9]/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
};

export const formatString = (value: string, pattern: string) => {
  var i = 0,
    v = value.toString();
  return pattern.replace(/#/g, (_) => v[i++]);
};
